import {PipelineSimplifiedExtractSteps, TaskManagerTaskColors, TaskManagerStates} from '@/enum';
class vmLogEntry {
    constructor(data) {
        this.entry = data ? data : {};
    }

    getVmTime(rawMinutes = false) {
        const {vmStartedAt, vmStoppedAt} = this.entry;
        if(vmStartedAt && vmStoppedAt) {
            const start = new Date(vmStartedAt);
            const end = new Date(vmStoppedAt);
            const diff = end - start;
            const seconds = diff / 1000;
            const minutes = seconds / 60;
            const hours = minutes / 60;
            if(rawMinutes) {
                return diff / 1000 / 60;
            }
            if(hours < 1) {
                return `${minutes.toFixed(2)}min`;
            } else {
                return `${hours.toFixed(2)}h`;
            }
        }
        return 0;
    }

    getTotalTime() {
        const {startedAt, stoppedAt, updatedAt} = this.entry;
        let stopTime = stoppedAt ? stoppedAt : updatedAt;
        if(startedAt && stopTime) {
            const start = new Date(startedAt);
            const end = new Date(stopTime);
            const diff = end - start;
            const seconds = diff / 1000;
            const minutes = seconds / 60;
            const hours = minutes / 60;
            if(hours < 1) {
                return `${minutes.toFixed(2)}min`;
            } else {
                return `${hours.toFixed(2)}h`;
            }
        }
        return 'n/a';
    }

    getConfig() {
        return this.entry.config;
    }

    getCreationUserId() {
        const config = this.getConfig();
        return config ? config.startedBy : '-';
    }

    getAbortUserId() {
        const config = this.getConfig();
        return config ? config.abortUserId : '-';
    }

    getCreatedAtString() {
        return this.entry.createdAt ? new Date(this.entry.createdAt).toLocaleString('de-DE') : '-';
    }

    getUpdatedAtString() {
        return this.entry.updatedAt ? new Date(this.entry.updatedAt).toLocaleString('de-DE') : '-';
    }

    isValid() {
        return this.entry && this.entry.config && this.entry.config.pipeline;
    }

    getFiles() {
        const config = this.getConfig();
        const files = config ? config.files : [];
        return files ? files.map(file => {
            if(file.includes('/')) {
                file = file.split('/').pop();
            }
            return file;
        }) : [];
    }
    getPrice() {
        const vmTime = this.getVmTime(true);
        if(!vmTime) {
            return 0;
        }
        const price = this.entry.clientPricePerMinute * this.getVmTime(true);
        return price.toFixed(2) + ' CHF';
    }
    getLatestStep() {
        const {stats} = this.entry;
        const keys = Object.keys(stats);
        if(keys && keys.length > 0) {
            const {taskName} = stats[keys[keys.length - 1]];
            if(taskName) {
                const entries = Object.entries(PipelineSimplifiedExtractSteps);
                const targetEntry = entries.find((entry) => {
                    return entry[1] === taskName;
                });
                if(targetEntry) {
                    return targetEntry[0];
                }
                return 'pipeline.' + taskName;
            }
        }
        return 'n/a';
    }
    getAllSteps() {
        const {stats} = this.entry;
        const keys = Object.keys(stats);
        if(keys && keys.length > 0) {
            return keys.map(key => {
                const {taskName} = stats[key];
                return taskName;
            });
        }
        return [];
    }
    getStats() {
        return this.entry ? this.entry.stats : {};
    }
    getPipelineState() {
        const {config} = this.entry;
        const {lastKnownTaskStatus} = config;
        if(lastKnownTaskStatus || lastKnownTaskStatus === 0) {
            return {
                color: TaskManagerTaskColors[lastKnownTaskStatus],
                name: 'pipeline.' + TaskManagerStates[lastKnownTaskStatus]
            };
        } else {
            return this.getPipelineLegacyState();
        }
    }
    getPipelineLegacyState() {
        const {errors} = this.entry;
        if(errors && errors.length > 0) {
            return {
                color: '#9f1b04',
                name: 'pipeline.ErroredImporting'
            };
        } else {
            return {
                color: '#195612',
                name: 'pipeline.SuccessfullyInmported'
            };
        }
    }
    getPipelineTask() {
        return this.entry ? this.entry.task : 'n/a';
    }
}

export default vmLogEntry;